export const ROUTES = {
  APP: '/',
  LOGIN: '/login',
  MONITORING: '/monitoring',
  TASKS: '/tasks',
  TASKS_ADD: '/tasks/add',
  TASKS_EDIT: '/tasks/edit/:id',
  TASKS_VIEW: '/tasks/view/:id',
  TASKS_MORE: '/tasks/more/:id',
  EMPLOYEES: '/employees',
  MACHINERY: '/machinery',
  UNITS: '/units',
  FARMLANDS: '/farmlands',
  FARMLANDS_ADD: '/farmlands/add',
  FARMLANDS_EDIT: '/farmlands/edit/:id',
  STATISTIC: '/statistic',
  DEVICES: '/devices',
  DEVICES_ADD: '/devices/add',
  DEVICES_EDIT: '/devices/edit/:id',
  CALIBRATIONS: '/calibrations',
  CALIBRATION_ADD: '/calibrations/add',
  CALIBRATION_EDIT: '/calibrations/edit/:id',
};
